
import '@accessible360/accessible-slick';
//require('@accessible360/accessible-slick');

import * as tns from "tiny-slider/src/tiny-slider";

function init() {
  InitIconSlider();
  InitHeroProductSlider();
  InitProductDetailSlider();
  InitBoughtTogether();
  InitAwardsSlider();
  InitFoundationSlider();
  InitPerformanceHighlightHeroSlider();
  InitTabbedTable();
  InitReasonAccordion();
}
function InitIconSlider() {
    if (document.querySelector('.icon-slider')) {
      let iconSlider;
  
  
  
      iconSlider = tns({
        container: ".icon-slider",
        items: 1,
        lazyload: true,
        mode: 'gallery',
  
        controlsContainer: "#icon-slider-nav",
        mouseDrag: true,
        autoplayHoverPause: false,
  
  
        slideBy: 1,
  
        responsive: {
          641: {
            disable: true,
          }
        },   /**/
      })
  
    }
  }
  
  const onInit = function (info) {
    info.controlsContainer.setAttribute('tabindex', -1);
    // info.nextButton.setAttribute('tabindex', 0);
    // info.prevButton.setAttribute('tabindex', 0);
  }
  
  function InitHeroProductSlider() {
    if (document.querySelector('.hero__product-slider')) {
      let slider = tns({
        container: ".hero__product-slider",
        items: 1,
        lazyload: true,
        onInit: onInit,
        controlsContainer: "#customize-controls",
        responsive: {
          640: {
            edgePadding: 20,
            gutter: 20,
            items: 2,
          },
          900: {
            items: 3,
          },
          1024: {
            items: 2,
          },
          1250: {
            items: 3,
          },
          1500: {
            items: 4,
          },
        },
      });
    }
  }
  
  function InitProductDetailSlider() {
    if (document.querySelector('.product-detail-slider')) {
      let slider = tns({
        container: ".product-detail-slider",
        items: 1,
        lazyload: true,
        controlsContainer: "#customize-controls-product",
        navContainer: '.product-detail-thumbnails',
        slideBy: 'page',
        edgePadding: 0,
        gutter: 0,
        loop: false,
        mouseDrag: true,
        autoplayHoverPause: false,
      });
      slider.events.on('indexChanged', evt => nextSlide(evt));
      let thumbnails = tns({
        container: ".product-detail-thumbnails",
        items: 5,
        lazyload: true,
        controlsContainer: "#customize-controls-product",
        loop: false,
        slideBy: 1,
        edgePadding: 10,
        gutter: 10,
      });
  
      const productThumbnails = $('.product-detail-thumbnails').children()
      // console.log(productThumbnails, productThumbnails.length, 'thumbnails?')
  
      const numThumbnails = productThumbnails.length - 4;
      const additionalNumber = `<div class="additional-number">+${numThumbnails}</div>`;
      if (productThumbnails.length > 5) {
        $('.product-detail-thumbnails').parents('.tns-outer').append(additionalNumber);
      }
  
      let currentSlide = 0;
  
      function nextSlide(evt) {
        if (document.body.clientWidth > 1024) {
          if (numThumbnails - (evt.index) > 0) {
            $('.additional-number').fadeIn(250);
            $('.additional-number').text(`+${numThumbnails - (evt.index)}`);
          } else {
            $('.additional-number').hide();
          }
          currentSlide = evt.index - 1;
          thumbnails.goTo(evt.index - 1);
        }
      };
    }
  
    // -------------------------------------------------------------------------------------------------------
    if (document.querySelector('.product-spec-slider')) {
      try {
        let sliders = $(".product-spec-slider");
  
        if (sliders != null && sliders.length > 0) {
          for (let i = 0; i < sliders.length; i++) {
            let slider = $(sliders[i]);
  
            let tsliderid = slider.attr("id");
            if (tsliderid == null) continue;
  
            let sliderId = "#" + tsliderid;
  
            let thumbsId = "#" + slider.attr("s-thumbs-id");
            let controlsId = "#" + slider.attr("s-controls-id");
  
            let additionalNumberId = "additional-" + slider.attr("id");
            let additionalNumberIdSelector = "#" + additionalNumberId;
  
            let sliderContainer = $(sliderId)[0];
            let thumbsContainer = $(thumbsId)[0];
  
            // console.log(sliderContainer);
            // console.log(thumbsContainer);
  
            let controls = true;
            let controlsContainer = null;
            let controlsContainerTemp = $(controlsId);
            if (controlsContainerTemp != null && controlsContainerTemp.length > 0) {
              controlsContainer = $(controlsId)[0];
            }
            else {
              controls = false;
            }
  
            let sliderx = tns({
              container: sliderContainer,
              items: 1,
              lazyload: true,
              controlsContainer: controlsContainer,
              navContainer: thumbsContainer,
              slideBy: 'page',
              edgePadding: 0,
              gutter: 0,
              loop: false,
              mouseDrag: true,
              autoplayHoverPause: false,
              navAsThumbnails: true,
              controls: controls
            });
  
            let thumbnails = tns({
              container: thumbsContainer,
              items: 5,
              lazyload: true,
              controlsContainer: controlsContainer,
              loop: false,
              slideBy: 1,
              edgePadding: 10,
              gutter: 10,
              controls: controls
            });
  
            const productThumbnails = $(thumbsId).children();
  
            //console.log(productThumbnails);
  
            let additionalNumberExists = false;
            const numThumbnails = productThumbnails.length - 4;
            const additionalNumber = `<div id="${additionalNumberId}" class="additional-number2">+${numThumbnails}</div>`;
            if (productThumbnails.length > 5) {
              let parents = $(thumbsId).parents('.tns-outer');
              //console.log(parents);
              parents.append(additionalNumber);
              additionalNumberExists = true;
            }
  
            let currentSlide = 0;
  
            let nextSlide = function (evt) {
  
              // console.log(additionalNumberExists);
              // console.log(additionalNumberIdSelector);
              // console.log(evt);
  
              if (additionalNumberExists) {
                if (document.body.clientWidth > 1024) {
                  if (numThumbnails - (evt.index) > 0) {
                    $(additionalNumberIdSelector).fadeIn(250);
                    $(additionalNumberIdSelector).text(`+${numThumbnails - (evt.index)}`);
                  } else {
                    $(additionalNumberIdSelector).hide();
                  }
                  currentSlide = evt.index - 1;
                  thumbnails.goTo(evt.index - 1);
                }
              }
            };
  
            sliderx.events.on('indexChanged', function (evt) {
              nextSlide(evt);
            });
  
            let resizeFunc = function () {
              if (document.body.clientWidth > 1024) {
                $(additionalNumberIdSelector).fadeIn(250);
              }
              else {
                $(additionalNumberIdSelector).hide();
              }
  
              let sliderBoxes = slider.find(".slider-img-container");
              let sliderImgs = slider.find("img");
              sliderBoxes.css("height", "");
              if (sliderImgs != null && sliderImgs.length > 0) {
                let maxHeight = 0;
                for (let q = 0; q < sliderImgs.length; q++) {
                  let si = $(sliderImgs[q]);
                  let sih = si.height();
                  if (sih > maxHeight)
                    maxHeight = sih;
                }
                sliderBoxes.height(maxHeight);
              }
  
              let sliderCaps = slider.find(".caption");
  
              if (sliderCaps != null && sliderCaps.length > 0) {
                sliderCaps.css("height", "");
                let maxHeight = 0;
                for (let q = 0; q < sliderCaps.length; q++) {
                  let si = $(sliderCaps[q]);
                  let sih = si.height();
                  if (sih > maxHeight)
                    maxHeight = sih;
                }
                sliderCaps.height(maxHeight);
              }
  
              let thumbs = $(thumbsId);
              //console.log(thumbs);
              let thumbsBoxes = thumbs.find(".product-thumb-container");
              //console.log(thumbsBoxes);
              let thumbsImgs = thumbs.find("img");
              thumbsBoxes.css("height", "");
              if (thumbsImgs != null && thumbsImgs.length > 0) {
                let maxHeight = 0;
                for (let q = 0; q < thumbsImgs.length; q++) {
                  let si = $(thumbsImgs[q]);
                  let sih = si.height();
                  if (sih > maxHeight)
                    maxHeight = sih;
                }
                thumbsBoxes.height(maxHeight);
                $(additionalNumberIdSelector).height(maxHeight);
              }
            };
  
            let debounce = 10;
  
            let resizeInterval = setTimeout(function () {
              resizeFunc();
            }, debounce);
  
            addEventListener("resize", function (e) {
              this.clearTimeout(resizeInterval);
              resizeInterval = setTimeout(function () {
                resizeFunc();
              }, debounce);
            });
  
            // -------------------------------------------------------------------------------------------------------
          }
        }
      }
      catch (e) {
        console.error(e);
      }
    }
  
    if (document.querySelector('.table-load-more')) {
      try {
        let tables = $(".table-load-more");
  
        if (tables != null && tables.length > 0) {
          for (let i = 0; i < tables.length; i++) {
            let tableEl = tables[i];
            let table = $(tableEl);
            let tableId = table.attr("id");
  
            try {
              let rowsTemp = table.attr("tlm-rows");
              if (rowsTemp == null || rowsTemp == "")
                rowsTemp = "5";
              let rows = parseInt(rowsTemp, 10);
  
              let tbody = table.children("tbody")[0];
  
              let trs = $(tbody).children("tr");
  
              if (trs != null && trs.length > 0) {
                if (trs.length-1 > rows) {
  
                  let footid = tableId + "-foot";
                  let footbutton = tableId + "-footbutton";
                  let remaining = trs.length - rows - 1;
  
                  let foot = $(`<tfoot id="${footid}"><tr><td></td><td colspan="99" class="footcell"><button id="${footbutton}" aria-label="Load more" class="w100 btn btn--subtle u-txt-sm footbutton">Load More (${remaining})</button></td></tr></tfoot>`);
                  table.append(foot);
  
                  let jqfoot = $("#" + footbutton);
  
                  for (let rowi = 0; rowi < trs.length; rowi++) {
                    if (rowi > rows) {
                      $(trs[rowi]).addClass("u-hidden");
                    }
                  }
  
                  jqfoot.on("click", function () {
  
                    let ztable = $("#" + tableId);
                    let zfoot = $("#" + footid);
                    let zfootbutton = $("#" + footbutton);
  
                    let zrowsTemp = ztable.attr("tlm-rows");
                    if (zrowsTemp == null || zrowsTemp == "")
                      zrowsTemp = "5";
                    let zrows = parseInt(zrowsTemp, 10);
  
                    let ztbody = ztable.children("tbody")[0];
  
                    let ztrs = $(ztbody).children("tr");
  
                    let total = ztrs.length;
                    let unhidden = 0;
                    let hidden = 0;
                    for (let r = 0; r < ztrs.length; r++) {
                      let trjq = $(ztrs[r]);
                      if (trjq.hasClass("u-hidden")) hidden++;
                      else unhidden++;
                    }
  
                    let rowUnhideStart = unhidden;
                    let rowUnhideEnd = rowUnhideStart + zrows;
  
                    hidden = 0;
                    unhidden = 0;
  
                    for (let r = 0; r < ztrs.length; r++) {
                      let trjq = $(ztrs[r]);
  
                      if (r >= rowUnhideStart && r < rowUnhideEnd) {
                        trjq.removeClass("u-hidden");
                      }
  
                      if (trjq.hasClass("u-hidden")) hidden++;
                      else unhidden++;
                    }
  
  
                    let remaining = total - unhidden;
    
                    if (remaining <= 0) {
                      zfoot.remove();
                    }
                    else {
                      zfootbutton.text(`Load More (${remaining})`)
                    }
                  });
                }
              }
  
            }
            catch (e) {
              console.error(e);
            }
  
            table.removeClass("u-hidden");
          }
        }
      }
      catch (e) {
        console.error(e);
      }
    }
  }
  
  
  function InitBoughtTogether() {
    if (document.querySelector('.frequently-bought-together')) {
      if ($('.frequently-bought-slider').children().length > 0) {
        $('.frequently-bought-slider').slick({
          dots: false,
          accessibility: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          arrows: true,
          nextArrow: '.frequently-bought-together .next',
          prevArrow: '.frequently-bought-together .prev',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                centerPadding: '20px',
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                centerPadding: '10px',
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
  
        $('.frequently-bought-together .next').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.frequently-bought-slider').slick('slickNext');
          }
        })
        $('.frequently-bought-together .prev').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.frequently-bought-slider').slick('slickPrev');
          }
        })
  
      }
      else {
        $('.frequently-bought-together').remove();
      }
    }
  }
  
  function InitAwardsSlider() {
    if (document.querySelector('.awards-slider')) {
      if ($('.awards-slider .slides').children().length > 0) {
        $('.awards-slider .slides').on('init', function (e, slick) {
          $(this).parent().parent().find('.page').text('1 / ' + $('.awards-slider .slide').length);
        });
        $('.awards-slider .slides').slick({
          dots: false,
          accessibility: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          arrows: true,
          nextArrow: '.awards-slider .forward',
          prevArrow: '.awards-slider .back',
        });
        $('.awards-slider .slides').on('afterChange', function (slick, currentSlide) {
          $(this).parent().parent().find('.page').text(currentSlide.currentSlide + 1 + ' / ' + $('.awards-slider .slide').length);
        });
        $('.awards-slider .forward').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.awards-slider .slider').slick('slickNext');
          }
        })
        $('.awards-slider .back').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.awards-slider .slider').slick('slickPrev');
          }
        })
  
      }
      else {
        $('.awards-slider').remove();
      }
    }
  }
  
  function InitPerformanceHighlightHeroSlider() {
    if (document.querySelector('.performance-highlight-hero')) {
      if ($('.performance-highlight-hero .items').children().length > 0) {
        $('.performance-highlight-hero .items').slick({
          dots: true,
          accessibility: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          arrows: false,
        });
      }
      else {
        $('.performance-highlight-hero .items').remove();
      }
    }
  }
  
  function InitFoundationSlider() {
    if (document.querySelector('.foundation-slider')) {
      if ($('.foundation-slider .slides').children().length > 0) {
        $('.foundation-slider .slides').slick({
          dots: false,
          accessibility: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          arrows: true,
          nextArrow: '.foundation-slider .forward',
          prevArrow: '.foundation-slider .back',
        });
        $('.foundation-slider .forward').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.foundation-slider .slider').slick('slickNext');
          }
        })
        $('.foundation-slider .back').on('keydown', (e) => {
          if (e.code === 'Enter') {
            $('.foundation-slider .slider').slick('slickPrev');
          }
        })
  
      }
      else {
        $('.foundation-slider').remove();
      }
    }
  }
  
  function InitTabbedTable() {
    if (document.querySelector('.tabbed-table')) {
      $('.tabbed-table .anchors a').first().addClass('active');
      $('.tabbed-table table').first().addClass('active');
  
      $('.tabbed-table .anchors a').on('click', function (e) {
        e.preventDefault();
        $('.tabbed-table .anchors a, .tabbed-table table').removeClass('active');
        $(this).addClass('active');
        $('.tabbed-table table:nth-child(' + ($(this).index() + 1) + ')').addClass('active');
      });
    }
  }
  
  function InitReasonAccordion() {
    if (document.querySelector('.reason-accordion')) {
      $('.reason-accordion .anchors a').first().addClass('active');
      $('.reason-accordion .info').first().addClass('active');
  
      // Show Info On Click
      $('.reason-accordion .anchors a').on('click', function (e) {
        e.preventDefault();
        $('.reason-accordion .anchors a, .reason-accordion .info').removeClass('active');
        $(this).addClass('active');
        $('.reason-accordion .info:nth-child(' + ($(this).index() + 1) + ')').addClass('active');
      });
  
      // Show info on hover
      $('.reason-accordion .anchors a').on('mouseenter', function () {
        $(this).trigger('click');
      });
    }
  }
export {
    init
}